export const appSettingsAppGroupIdMessagePrioritizationCategoriesData =
  "/app_settings/:app_group_id/message_prioritization/categories_data";
